import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useBusinessNameBankAccountService from '../../../app/services/hooks/useBusinessNameBankAccountService';

interface Props {
    businessNameBankAccountId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const BusinessNameBankAccountSwitchChange = ({ businessNameBankAccountId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeBusinessNameBankAccount, fetchingActiveBusinessNameBankAccount } = useBusinessNameBankAccountService();

    const active = (value: boolean) => {
        setChecked(value);

        activeBusinessNameBankAccount(businessNameBankAccountId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={businessNameBankAccountId} callback={active} />;
};

export default BusinessNameBankAccountSwitchChange;
